import { path, createCachedSelector, defaultKeySelector } from '@cbridge-utils/redux';
import { IClientLp } from '../clientLp.interface';
import { clientLpStoreSelector } from '../clientLp.selector';

export const clientLpListSelector = createCachedSelector(
  [
    path(clientLpStoreSelector).data(),
    path(clientLpStoreSelector).listNetworkStatus(),
  ],
  (data, networkStatus) => {
    // Stub entries without lpId may appear when load.started/failed lands after the store was destroyed.
    const list: IClientLp[] = Object.values(data).filter((lp) => Boolean(lp.lpId));
    return {
      list,
      networkStatus,
    };
  },
)({
  keySelector: defaultKeySelector,
});
